const IS_STAGING = import.meta.env.MODE === 'staging';

export default function StagingBanner() {
  if (!IS_STAGING) return null;

  return (
    <div className="flex items-center justify-center bg-amber-500 px-3 py-1 text-center text-xs font-semibold text-white">
      ステージング環境 (本番データではありません)
    </div>
  );
}
